webpackJsonp([24262015346845],{

/***/ 786:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Reducers = __webpack_require__(57);
	
	var _Reducers2 = _interopRequireDefault(_Reducers);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _Reducers2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Extending & Overriding Reducers'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Given a project where a custom ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'tweet.count'
	      ),
	      ' reducer has been declared like so:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      src\n      |-reducers\n        |-tweet\n          |-count.js\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'This hook will find it and expose it on ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'lore.reducers.tweet.count'
	      ),
	      ' and make sure it\'s combined into the Redux store.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Reducers should follow this format:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      // file: src/reducers/tweet/count.js\n\n      module.exports = function count(state, action) {\n        state = state || 0;\n\n        switch (action.type) {\n          case ActionTypes.ADD_TWEET:\n            return state + 1;\n\n          default:\n            return nextState\n        }\n      };\n      ' })
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-reducers-extending-js-80cc3d49df9ad74cf880.js